/*function runOnSmallScreens() {
  jQuery(function($){
    $('.collection-nav-item h3').on('click', function(e){
        e.preventDefault();
        
        if($(this).parent().hasClass('active')){
          $(this).parent().removeClass('active');
          console.log('has class');
        }else{
          $('.collection-nav-item').removeClass('active');
          $(this).parent().addClass('active');
        }
        
    });
});
}

if (window.matchMedia("(max-width: 767px)").matches) {
  runOnSmallScreens();
}*/

function runOnSmallScreens() {
    // Select all h3 elements inside .collection-nav-item
    document.querySelectorAll('.collection-nav-item h3').forEach(function (header) {
        header.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default behavior
            
            const parent = this.parentElement; // Get the parent element
            
            // Check if the parent has the 'active' class
            if (parent.classList.contains('active')) {
                parent.classList.remove('active'); // Remove 'active' class
                console.log('has class');
            } else {
                // Remove 'active' class from all items
                document.querySelectorAll('.collection-nav-item').forEach(function (item) {
                    item.classList.remove('active');
                });
                parent.classList.add('active'); // Add 'active' class to the current item's parent
            }
        });
    });
}

if (window.matchMedia("(max-width: 767px)").matches) {
    runOnSmallScreens();
}